import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import AddIcon from '@mui/icons-material/Add';
import ListIcon from '@mui/icons-material/List';
import TimelineIcon from '@mui/icons-material/Timeline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import { ORDERSTATUS } from 'utils/Constants';

export default function ProjectsPageHeader({
    activeFilter = 'ALL',
    onFilterChange,
    filterRoutes,
    addButtonPath,
    onAddClick,
    hideAddButton = false,
    hideAllFilter = false,
    hideNonAttributedFilter = false,
}) {
    const { t } = useTranslation();
    const history = useHistory();

    const handleFilterClick = (status) => {
        if (onFilterChange) {
            onFilterChange(status);
            return;
        }
        if (filterRoutes?.[status]) {
            history.push(filterRoutes[status]);
        }
    };

    const handleAdd = () => {
        if (onAddClick) {
            onAddClick();
        } else if (addButtonPath) {
            history.push(addButtonPath);
        }
    };

    const filters = [
        !hideAllFilter && {
            key: 'ALL',
            label: t('Tous'),
            icon: <ListIcon style={{ fontSize: '16px' }} />,
        },
        !hideNonAttributedFilter && {
            key: ORDERSTATUS.NONATTRIBUTED,
            label: t('Non attribués'),
            icon: <TimelineIcon style={{ fontSize: '16px' }} />,
        },
        {
            key: ORDERSTATUS.INPROGRESS,
            label: t('En cours'),
            icon: <RadioButtonUncheckedIcon style={{ fontSize: '16px' }} />,
        },
        {
            key: ORDERSTATUS.DELAYED,
            label: t('En retard'),
            icon: <AccessTimeIcon style={{ fontSize: '16px' }} />,
        },
        {
            key: ORDERSTATUS.VALID,
            label: t('Validés'),
            icon: <CheckCircleOutlineIcon style={{ fontSize: '16px' }} />,
        },
    ].filter(Boolean);

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 0 20px 0',
                borderBottom: '1px solid #e6e4e4',
                marginBottom: '20px',
            }}
        >
            {/* Title + filter buttons */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flex: 1 }}>
                <h2
                    style={{
                        margin: 0,
                        fontSize: '24px',
                        fontWeight: 600,
                        color: '#3c3c3c',
                        marginRight: '20px',
                    }}
                >
                    {t('Projets')}
                </h2>

                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    {filters.map(({ key, label, icon }) => {
                        const isActive = activeFilter === key;
                        return (
                            <button
                                key={key}
                                onClick={() => handleFilterClick(key)}
                                style={{
                                    padding: '8px 16px',
                                    borderRadius: '8px',
                                    border: '1px solid #e0e0e0',
                                    backgroundColor: isActive ? '#f5f5f5' : '#ffffff',
                                    color: '#3c3c3c',
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    fontFamily: 'Poppins, sans-serif',
                                    transition: 'all 0.2s ease',
                                }}
                                onMouseEnter={(e) => {
                                    if (!isActive) e.currentTarget.style.backgroundColor = '#f9f9f9';
                                }}
                                onMouseLeave={(e) => {
                                    if (!isActive) e.currentTarget.style.backgroundColor = '#ffffff';
                                }}
                            >
                                {icon}
                                {label}
                            </button>
                        );
                    })}
                </div>
            </div>

            {/* Add button */}
            {!hideAddButton && (
                <button
                    onClick={handleAdd}
                    style={{
                        padding: '10px 20px',
                        borderRadius: '8px',
                        border: 'none',
                        backgroundColor: '#6458F1',
                        color: '#ffffff',
                        fontSize: '14px',
                        fontWeight: 500,
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontFamily: 'Poppins, sans-serif',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        transition: 'all 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#5548d1';
                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#6458F1';
                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                    }}
                >
                    <AddIcon style={{ fontSize: '18px' }} />
                    {t('Ajouter un projet')}
                </button>
            )}
        </div>
    );
}
